import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import InfiniteScroll from 'react-infinite-scroller';

import { DEFAULT_PAGE, defaultSorted } from '../constants';
import { DEFAULT_MATCHES_LIMIT } from '../../../constants';
import InfinityLoader from './InfinityLoader';

const MatchesTableInfinityScroll = (
  {
    columns,
    hasMoreMatches,
    loadMoreMatches,
    matches,
    selectable,
  }) => {
  const tableClassName = classNames(
    'c-table-new vendor-matches-table',
    {
      'vendor-matches-table__selectable': selectable,
    }
  );

  return (
    <div className="vendor-matches-table__container">
      <InfiniteScroll
        useWindow
        pageStart={DEFAULT_PAGE}
        loadMore={loadMoreMatches}
        hasMore={hasMoreMatches}
        loader={InfinityLoader}
      >
        <ReactTable
          data={matches}
          defaultPageSize={DEFAULT_MATCHES_LIMIT}
          defaultSorted={defaultSorted}
          showPagination={false}
          minRows={0}
          className={tableClassName}
          columns={columns}
        />
      </InfiniteScroll>
    </div>
  );
};

MatchesTableInfinityScroll.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hasMoreMatches: PropTypes.bool.isRequired,
  loadMoreMatches: PropTypes.func.isRequired,
  matches: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectable: PropTypes.bool,
};

MatchesTableInfinityScroll.defaultProps = {
  selectable: false,
};

export default MatchesTableInfinityScroll;
